import { PricingCard } from "@/components/ui/pricing-card";
import { useNavigate } from "react-router-dom";
import { usePricingPlans } from "@/hooks/useSupabaseData";

const PricingSection = () => {
  const navigate = useNavigate();
  const { plans, loading } = usePricingPlans();

  const handlePlanClick = (planName: string) => {
    const kiwifyUrls = {
      'Básico': 'https://pay.kiwify.com.br/PxRcy4j',
      'Premium': 'https://pay.kiwify.com.br/eQjC4l9', 
      'Pro': 'https://pay.kiwify.com.br/dDK9ZvE'
    };
    
    const url = kiwifyUrls[planName as keyof typeof kiwifyUrls];
    if (url) {
      window.open(url, '_blank');
    } else {
      navigate('/auth');
    }
  };

  if (loading) {
    return (
      <section id="planos" className="py-20 bg-background">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <div className="animate-pulse">
          <div className="h-8 bg-gray-200 rounded w-64 mx-auto mb-4"></div>
              <div className="h-4 bg-gray-200 rounded w-96 mx-auto"></div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-[1200px] mx-auto mb-16">
            {[1, 2, 3].map((i) => (
              <div key={i} className="animate-pulse">
                <div className="h-96 bg-gray-200 rounded-lg"></div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  // Filter out free plan for the main pricing display
  const paidPlans = plans.filter(plan => plan.name !== 'free');

  const guarantees = [
    {
      metric: "+150%",
      description: "Aumento nas vendas"
    },
    {
      metric: "15h/\nsemana",
      description: "Economia de tempo"
    },
    {
      metric: "300%",
      description: "ROI médio"
    },
    {
      metric: "+85%",
      description: "Taxa de conversão"
    }
  ];

  return (
    <section id="planos" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-6">
            Escolha Seu Plano
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Investimento que se paga sozinho com os primeiros resultados
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-[1200px] mx-auto mb-16">
        {paidPlans.map((plan, index) => {
  const isPopular = plan.display_name === "Pro"; 
  return (
    <PricingCard
      key={index}
      heading={plan.display_name}
      description={plan.description}
      price={plan.price_monthly.toString()}
      yearlyPrice={plan.price_yearly.toString()}
      buttonText={`Escolher ${plan.display_name}`}
      list={plan.features}
      popular={isPopular}
      popularBadge={isPopular ? "MAIS POPULAR" : undefined}
      className="w-full h-full"
      onButtonClick={() => handlePlanClick(plan.display_name)}
      aiCredits={{
        dailyTokens: plan.daily_ai_credits || 0,
        monthlyTokens: plan.monthly_ai_credits || 0,
        models: plan.allowed_models || []
      }}
    />
  );
})}

        </div>

        {/* Guarantee Section */}
        <div className="bg-muted/30 rounded-2xl p-8 mb-12">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-foreground mb-4">
              Transformação Garantida
            </h3>
            <p className="text-muted-foreground">
              Veja o que nossos membros conseguiram em apenas 30 dias:
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
            {guarantees.map((guarantee, index) => (
              <div key={index} className="text-center px-2">
                <div className="text-2xl md:text-3xl font-bold text-success mb-2 break-words">
                  {guarantee.metric.split('\n').map((line, i) => (
                    <span key={i}>
                      {line}
                      {i < guarantee.metric.split('\n').length - 1 && <br />}
                    </span>
                  ))}
                </div>
                <div className="text-xs md:text-sm text-muted-foreground">
                  {guarantee.description}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center">
          <p className="text-lg text-muted-foreground mb-4">
            🔒 Garantia de 7 dias ou seu dinheiro de volta
          </p>
          <p className="text-sm text-muted-foreground">
            Cancele quando quiser, sem multas ou burocracias
          </p>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;